export const AUDIO_PUB_LIST_KEY = 'audio-pub-list'
export const AUDIO_TAG_LIST_KEY = 'audio-tag-list'

export const DEFAULT_AUDIO_PUB_PAGE_SIZE = 20
